module.exports = __webpack_public_path__ + "31c125a7748707e660ccc8581a160707.pdf";